import {linkedin,github, google} from '../assets'

export const Socials = [
    {
        title: 'LinkedIn',
        path: 'https://www.linkedin.com/in/craig-mutugi',
        imgUrl: linkedin
    },
    {
        imgUrl:github,
        title: 'Github',
        path: 'https://github.com/cmm25'
    },
    {
        imgUrl:google,
        title: 'Google Cloud',
        path: 'https://www.cloudskillsboost.google/public_profiles/5a2eb07c-cc41-43d3-af8d-79515f1cacea'
    }
];